import React from 'react';
import { RegularText, Row, SizedBox } from 'src/components';

export const IconLabel = ({ icon, label }: { icon: React.ReactElement; label: string | React.ReactElement }) => {
  return (
    <Row middle>
      {icon}
      <SizedBox width="medium" />
      {typeof label === 'string' ? <RegularText fontWeight="bold">{label}</RegularText> : label}
    </Row>
  );
};
